import { render } from "./WarningPopup.vue?vue&type=template&id=65487b9a&scoped=true"
import script from "./WarningPopup.vue?vue&type=script&lang=js"
export * from "./WarningPopup.vue?vue&type=script&lang=js"

import "./WarningPopup.vue?vue&type=style&index=0&id=65487b9a&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65487b9a"]])

export default __exports__